import React, { useCallback,useState, useEffect, useMemo, useRef } from "react";
import styled from "styled-components";
import { useDebounce } from 'use-lodash-debounce'
import UnconfiguredComponent from '../common3/UnconfiguredComponent'
import get from 'lodash/get'
import { Link } from 'react-router-dom'
import DotLoader from '../common3/Loaders/DotLoader'
import produce from 'immer'

import Card from './Card'

import Row from '../Row'
import Col from '../Col'

const FavButton = styled.button`
 padding:0.3em 1.2em;
 margin:0 0.1em 0.1em 0;
 border:0.16em solid ${p=>!p.showLove ? 'red' : 'white'};
 border-radius:2em;
 box-sizing: border-box;
 text-decoration:none;
 color: ${p=>!p.showLove ? 'red' : 'white'};
 text-align:center;
 transition: all 0.2s;
  width:150px;

  background-color: ${p=>!p.showLove ? 'white' : 'red'};


  &:focus {outline:0;}

  &:hover{

  }

  @media all and (max-width:30em){
   button4{
    display:block;
    margin:0.2em auto;
   }
  }


`


const BreadCrumbs = styled.ul`
  margin-bottom:25px;
  display:flex;
  list-style:none;
  padding-left:0px;
`

const Crumb = styled.li`
    margin-right:5px;
    &:after {
      padding-left:5px;
      content: ' / ';
    }
    &:last-child:after {
      content: '';
    }
`

const StyledLink = styled(Link)`
  color:inherit;
  text-decoration:none;
`


const ProcessList = (props) => {

  const { extra = {}, runEffect,effects = {},id,queryParams = {}, setUserPersistentProfile, userPersistentProfile, user = null } = props;
  const { categoryId = null } = queryParams
  const { categories = [], to } = extra

  const [ love, _setLove ] = useState(userPersistentProfile && userPersistentProfile.loveProcess ? userPersistentProfile.loveProcess : {} )
  const [ showLove, setShowLove ] = useState(false )

  useEffect( () => {
    runEffect({source:'Components/ProcessList/get', effectId: id, context: {categories} })
  }, [])

  const mountRef = useRef()

  useEffect( () => {
    if( mountRef.current ) {
      setUserPersistentProfile({loveProcess: love})
    } else {
      mountRef.current = true;
    }

  }, [love])

  const setLove = useCallback( loveId => {
    _setLove( produce( d => {
      if( d[loveId] ) {
        d[loveId] = false
      } else {
        d[loveId] = true
      }
    }))



  })  



  const processList = get(effects,[id], null)

  const processMap = useMemo( () => {
    const output = {}
    processList && processList.map(category   => {
      if( category.structure ) {
        category.structure.map( p => {
          output[p.publishId] = p

        })
      }
    });
    return output
  }, [processList])
  
  const categoryName = useMemo( () => {
    
    let foundName = ''
    processList && processList.map(category   => {
      if( categoryId === category.categoryId ) {
        foundName = category.label
      }
    })

    return foundName

  }, [categoryId,processList])

  const categoryMap = useMemo( () => {
    
    const output = {}
    processList && processList.map(category   => {
      output[category.categoryId] = category
    })

    return output

  }, [processList])


  const categoryIds = useMemo( () => {
    if( !categories ) {
      return null
    }
    return categories.map(c   => {
      return c.categoryId
    })
  }, [categories])

  /**
   * BUILD BREADCRUMB
   */
  const breadArray = useMemo( () => {
    const c = categoryMap[categoryId]

    if( ! c ) {
      return []
    }

    const output = []

    if( c.folderId ) {
      const parent = categoryMap[c.folderId]
      output.push({
        label: parent.label,
        categoryId: parent.categoryId
      })
    }

    output.push({
      label: c.label,
      categoryId: c.categoryId
    })

    return output

  }, [categoryId,categoryMap])


  if( ! processList ) {
    return <DotLoader/>
  }




  return (
    <>
    <Row>
      <Col extra={{cols:'6'}}><BreadCrumbs><Crumb><StyledLink to={'?'}>Toppnivå</StyledLink></Crumb>{ breadArray.map( b => ( <Crumb><StyledLink to={`?categoryId=${b.categoryId}`}>{b.label}</StyledLink></Crumb> )) }</BreadCrumbs></Col>
      <Col extra={{cols:'6', style:{alignItems:'end'}}} >{ user && <FavButton showLove={showLove} onClick={() => setShowLove(!showLove)}>Mina favoriter</FavButton>} </Col> 

    </Row>
    <Row>
      {
          showLove && user && Object.keys(love).map((processId, i) => {

            if( ! love[processId]) {
              return null
            }

            const process = processMap[processId]
            return <Col extra={{cols:'4'}}><Card isProcess={true} label={process.name} description={process.description} processId={process.publishId} love={love} setLove={setLove} user={user} /></Col>
            
          })

      }
      {
        ! showLove && processList.map(category => {

          const { label, structure = [],description } = category


          // LIST PROCESSES
          if( categoryId === category.categoryId ) {
              return structure.map( process => {
                return <Col extra={{cols:'4'}}><Card isProcess={true} label={process.name} description={process.description} processId={process.publishId} love={love} setLove={setLove} user={user} origin={props.origin} to={to}/></Col>
              })
          }

          if( categoryId && category.folderId !== categoryId ) {
            return null
          } else if( !categoryId && ! categoryIds.includes(category.categoryId) ) {
            return null
          }


          return (
            <Col extra={{cols:'4'}}>
              <Card label={category.label} description={category.description}  categoryId={category.categoryId} love={love} setLove={setLove} />
            </Col>
          )
        })

      }
    </Row>
    </>
    
  );
};

export default ProcessList
